module.exports = __webpack_public_path__ + "img/ring_skip_0_1_1.b083479a.png";